import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

export default function PermissionRoute({ permission }) {
  const { user, isLoading } = useAuth();

  if (isLoading) return <div className="loading-screen">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;

  const required = Array.isArray(permission) ? permission : [permission];
  const hasPermission =
    user.isAdmin || required.some((item) => user.permissions?.includes(item));

  return hasPermission ? <Outlet /> : <Navigate to="/" replace />;
}
